import { Component, OnInit, OnDestroy } from '@angular/core';
import { User } from 'projects/core/src/lib/login/data/user';
import { UserService } from 'projects/core/src/lib/login/data/user.service';
import { ProjectHolder } from '../../../project-misc/interfaces/project-holder';
import { ProjectService } from '../../../project-misc/data/project/project.service';
import { filter, debounceTime, takeUntil } from 'rxjs/operators';
import { ProjectParticipant } from '../../../project-misc/data/project/project-participant';
import { Subject, Subscription, timer } from 'rxjs';
import { RxJSUnsubscribe } from 'projects/core/src/lib/core/utils/decorators/rxjs-unsubscribe-decorator';
import { RxJSUnsubscribable } from 'projects/core/src/lib/core/utils/interfaces/rxjs-unsubscribable';

export class Member {
    user: User;
    attached: boolean;
}

@Component({
    selector: 'app-add-user-popup',
    templateUrl: './add-user-popup.component.html',
    styleUrls: ['./add-user-popup.component.scss']
})
@RxJSUnsubscribe
export class AddUserPopupComponent implements OnInit, OnDestroy, RxJSUnsubscribable {

    user: User;

    projectId: number;
    participants: ProjectParticipant[];

    members: Member[] = [];

    projectManagerId: number;

    timer: Subscription;

    constructor(
        protected userService: UserService,
        protected projectHolder: ProjectHolder,
        private projectService: ProjectService
    ) {
        this.projectId = this.projectHolder.project.id
        this.participants = this.projectHolder.project.participants

        if (this.projectHolder.project.projectManager) {
            this.projectManagerId = this.projectHolder.project.projectManager.id
        }
    }

    ngOnInit() {
        this.updateUsers();
        this.projectService.projectEmitter.update
            .pipe(
                filter(event => this.projectId === event.entityId),
                debounceTime(200),
                takeUntil(this.getUnsubFromAllSubs())
            )
            .subscribe(event => {
                if (!this.timer) {
                    this.timer = timer(50).pipe(takeUntil(this.getUnsubFromAllSubs()), debounceTime(200)).subscribe(emit => {
                        const project = event.entity
                        this.participants = project.participants

                        if (project.projectManager) {
                            this.projectManagerId = project.projectManager.id
                        }

                        this.updateUsers();
                    })
                }
                else {
                    this.timer.unsubscribe();
                }
            })
    }

    updateUsers() {
        this.userService.getActiveUsers().pipe(
            debounceTime(200),
            takeUntil(this.getUnsubFromAllSubs())
        ).subscribe(users => {
            users.sort((a, b) => {
                if (a.name < b.name) { return -1; }
                if (a.name > b.name) { return 1; }
                return 0;
            })

            const attachedMembersSet = new Set();
            this.participants.forEach(ptsp => {
                attachedMembersSet.add(ptsp.user.username);
            })
            this.members = users.map(user => ({
                user,
                attached: attachedMembersSet.has(user.username)
            }))
        })

    }

    addUser(userId: number) {
        this.projectService
            .atachUser(this.projectId, userId)
            .subscribe(project => {
                this.participants = project.participants
            })
    }

    toggleUser(userId: number, status: boolean) {
        if (status) {
            this.projectService
                .detachUser(this.projectId, userId)
                .subscribe(project => {
                    this.participants = project.participants
                    this.members.find(member => member.user.id === userId).attached = !status
                })
        }
        else {
            this.projectService
                .atachUser(this.projectId, userId)
                .subscribe(project => {
                    this.participants = project.participants
                    this.members.find(member => member.user.id === userId).attached = !status
                })
        }
    }

    ngOnDestroy() {

    }

    getUnsubFromAllSubs(): Subject<boolean> {
        return null
    }
}
